const routesConfig = {
  CLAIM_STATUS: { path: '/claim-status', regexPath: /\/claim-status[/]{0,1}$/, subPageName: 'ClaimStatus' },
  REGISTRATION: { path: '/registration', regexPath: /\/registration[/]{0,1}$/, subPageName: 'Registration' },
  CONFIRMATION: { path: '/confirmation', regexPath: /\/confirmation[/]{0,1}$/, subPageName: 'Confirmation' },
  ERROR: { path: '/error', regexPath: /\/error[/]{0,1}$/, subPageName: 'Error' },
  CLAIM_SEARCH: { path: '/claim-search', regexPath: /\/claim-search[/]{0,1}$/, subPageName: 'ClaimSearch' },
  ROOT: { path: '/', regexPath: /^\/$/, subPageName: 'Root' },
  SETTINGS: { path: '/settings', regexPath: /\/settings[/]{0,1}$/, subPageName: 'Settings' },
  LEARN_MORE: { path: '/settings/learn-more', regexPath: /\/settings\/learn-more[/]{0,1}$/, subPageName: 'LearnMore' },
  RESET_MFA_SUCCESS: { path: '/settings/success', regexPath: /\/settings\/success[/]{0,1}$/, subPageName: 'ResetMfaSuccess' },
  // Add new routes here as required
};

export default routesConfig;